import React from "react";
import { Link } from "react-router-dom";

export function HoneypotField({ value, onChange }) {
  return <input type="text" name="website_url" value={value} onChange={onChange} style={{ position: "absolute", left: "-9999px", opacity: 0, height: 0, width: 0 }} tabIndex={-1} autoComplete="off" data-testid="honeypot-field" />;
}

export function SMSConsentBox({ checked, onChange, testId, compact }) {
  return (
    <div className={`sms-consent-box${compact ? " sms-consent-compact" : ""}`} data-testid={testId || "sms-consent-box"}>
      <label className="sms-consent-label">
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span>I agree to receive SMS appointment confirmations and service updates from Lazy Days Home Services LLC at the phone number provided. Message frequency: up to 4 messages per month. Msg &amp; data rates may apply. Reply STOP to unsubscribe, HELP for help. Consent is not required to purchase services.</span>
      </label>
      <div className="sms-consent-links">View our <Link to="/sms-policy" target="_blank">SMS Terms &amp; Conditions</Link> and <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>.</div>
    </div>
  );
}
